"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lendingPool_1 = __importDefault(require("./lendingPool"));
const onchainAccountLendingVault_1 = __importDefault(require("./onchainAccountLendingVault"));
const merkle_distributors_1 = require("../../config/endpoints/merkle-distributors");
const ethers_1 = require("ethers");
class OnchainAccount {
    constructor(onchain, account) {
        this.cache = { airdropData: {}, claimableIBEX: {} };
        this.getOnchain = () => this.onchain;
        this.getAccountAddress = () => this.accountAddress;
        this.getInteractions = () => this.onchain.getInteractions(this.accountAddress);
        this.getOffchainAccount = () => this.onchain.getOffchain().getAccount(this.accountAddress);
        this.onchain = onchain;
        this.accountAddress = account;
        this.lendingPools = {};
        this.lendingVaults = {};
    }
    cleanCache() {
        return __awaiter(this, void 0, void 0, function* () {
            this.cache = { airdropData: {}, claimableIBEX: {} };
            for (const factory in this.lendingPools) {
                for (const pairAddress in this.lendingPools[factory]) {
                    (yield this.lendingPools[factory][pairAddress]).cleanCache();
                }
            }
            for (const vaultAddress in this.lendingVaults) {
                (yield this.lendingVaults[vaultAddress]).cleanCache();
            }
        });
    }
    initializeLendingPool(factory, pair) {
        const lendingPool = this.onchain.getImpermaxFactory(factory).getLendingPool(pair);
        return new lendingPool_1.default(this, lendingPool);
    }
    getLendingPool(factory, pair) {
        if (!this.lendingPools[factory])
            this.lendingPools[factory] = {};
        const accountLendingPools = this.lendingPools[factory];
        if (!accountLendingPools[pair])
            accountLendingPools[pair] = this.initializeLendingPool(factory, pair);
        return accountLendingPools[pair];
    }
    initializeLendingVault(vaultAddress) {
        const lendingPool = this.onchain.getLendingVault(vaultAddress);
        return new onchainAccountLendingVault_1.default(this, lendingPool);
    }
    getLendingVault(vaultAddress) {
        if (!this.lendingVaults[vaultAddress])
            this.lendingVaults[vaultAddress] = this.initializeLendingVault(vaultAddress);
        return this.lendingVaults[vaultAddress];
    }
    // Mass Available Reward (only supports ImpermaxChef)
    getMassAvailableReward(pairs) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = {};
            if (!pairs)
                return result;
            const requests = [];
            for (const factory in pairs) {
                const requestsLocal = [];
                for (const pairAddress of pairs[factory]) {
                    requestsLocal.push((yield this.getLendingPool(factory, pairAddress)).getAvailableReward());
                }
                requests.push(Promise.all(requestsLocal));
            }
            const data = yield Promise.all(requests);
            let i = 0;
            for (const factory in pairs) {
                result[factory] = {};
                for (let j = 0; j < pairs[factory].length; j++) {
                    result[factory][pairs[factory][j]] = data[i][j];
                }
                i++;
            }
            return result;
        });
    }
    // Airdrop Data
    initializeAirdropData(airdropURL, merkleDistributor) {
        return __awaiter(this, void 0, void 0, function* () {
            if (airdropURL && airdropURL !== '') {
                try {
                    const json = yield fetch(airdropURL + '/' + this.accountAddress);
                    const data = yield json.json();
                    if (data) {
                        data.amount = ethers_1.BigNumber.from(data.amount);
                        const isClaimed = yield merkleDistributor.methods.isClaimed(data.Account).call();
                        if (!isClaimed)
                            return data;
                    }
                }
                catch (e) { }
            }
            return {
                index: -1,
                amount: null,
                proof: [],
            };
        });
    }
    getAirdropData(airdropURL, merkleDistributor) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cache.airdropData[airdropURL])
                this.cache.airdropData[airdropURL] = this.initializeAirdropData(airdropURL, merkleDistributor);
            return this.cache.airdropData[airdropURL];
        });
    }
    getIbexAirdropData() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getAirdropData(merkle_distributors_1.MERKLE_URL_IBEX[this.onchain.network], this.onchain.getContractHelper().merkleDistributorIbex);
        });
    }
    getIbex2AirdropData() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getAirdropData(merkle_distributors_1.MERKLE_URL_IBEX_2[this.onchain.network], this.onchain.getContractHelper().merkleDistributorIbex2);
        });
    }
    getEthAirdropData() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getAirdropData(merkle_distributors_1.MERKLE_URL_ETH[this.onchain.network], this.onchain.getContractHelper().merkleDistributorEth);
        });
    }
    hasIbexClaimableAirdrop() {
        return __awaiter(this, void 0, void 0, function* () {
            const airdropData = yield this.getIbexAirdropData();
            if (airdropData.amount)
                return true;
            return false;
        });
    }
    hasEthClaimableAirdrop() {
        return __awaiter(this, void 0, void 0, function* () {
            const airdropData = yield this.getEthAirdropData();
            if (airdropData.amount)
                return true;
            return false;
        });
    }
    // Claim Claimable IBEX
    initializeClaimableIBEX(claimableAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const claimable = this.onchain.getContractHelper().newClaimable(claimableAddress);
            return (yield claimable.methods.claim().call({ from: this.accountAddress })) / 1e18;
        });
    }
    getClaimableIBEX(claimableAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cache.claimableIBEX[claimableAddress])
                this.cache.claimableIBEX[claimableAddress] = this.initializeClaimableIBEX(claimableAddress);
            return this.cache.claimableIBEX[claimableAddress];
        });
    }
}
exports.default = OnchainAccount;
